export default __webpack_public_path__ + "static/banner-mobile-ppc-2-ebb987dc524f3d62aa0e806e1501b781.png";